import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
@Component({
    selector: 'app-nav-bar-mobile',
    templateUrl: './nav-bar-mobile.component.html',
    styleUrls: ['./nav-bar-mobile.component.css'],
    standalone: false
})
export class NavBarMobileComponent implements OnInit {
  @Output() openSideNav = new EventEmitter<boolean>();
  
  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    //this.route.data.subscribe(res => this.)
  }

  isSearchRoute() {
    return this.router.url === '/user-hist';
  }

  isAllContactsRoute() {
    return this.router.url === '/contact-list';
  }

  isProfileRoute() {
    return this.router.url.includes('/user-profile') || this.router.url.includes('/my-profile');
  }

  onOpenSideNav(): void{
    this.openSideNav.emit(true);
  }

  backToSearchResults(): void {
    this.router.navigate( ['user-hist'] );
  }  

}
